
import React from "react";
import "./SailPointIdentityNowCard.css";
import MenuNavbar from "../../MenuNavbar";
import Floaticons from "../../Floaticons";
import Tabs from "@mui/material/Tabs";
import PropTypes from "prop-types";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IdentiyAccessManagement from "../IdentityManagement/IdentityandAccessManagement";
import InfrastructureSecurity from "../InfrastructureSecurity/InfrastructureSecurity";
import PlatformSecurity from "../PlatformSecurity/PlatformSecurity";
import CloudSecurity from "../CloudSecurity/CloudSecurity";
//import "./SecurityLearningFramework.css";
import "../SecurityPlatforms.css";
import Link from "@mui/material/Link";
import HomeIcon from "@mui/icons-material/Home";
import { Breadcrumbs } from "@material-ui/core";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 4 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function SailPointIdentityNow() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <div className="banner-container">
        <img
          src="images/SecuritySchools/SailPoint/school-banner.png"
          alt="banner"
          className="banner-img"
        />
        <div className="breadcrumbs-container">
          <Breadcrumbs separator=">" color="#fff">
            <Link
              underline="hover"
              sx={{ display: "flex", alignItems: "center" }}
              color="#fff"
              href="/"
            >
              <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            </Link>
            ,
            <Link
              underline="hover"
              key="2"
              color="#fff"
              href="/securityLearningFramework"
              // onClick={handleClick}
            >
              Security Learning Framework
            </Link>
            ,
            <Typography key="3" color="#fff">
              Security Schools
            </Typography>
            ,
          </Breadcrumbs>
        </div>
        <div className="banner-content">
          <h1>Security Schools</h1>
          <i>
            Lorem ipsum is a dummy text of the printing and typesetting industry
          </i>
        </div>
        <MenuNavbar />
      </div>
      <Floaticons />
      <div className="breadcrumbLinks">
        <Breadcrumbs separator=">" aria-label="breadcrumb">
          <a className="menu_title" href="/securitySchools">
            <img src="/images/SecuritySchools/Back-button.png" />
            Security Schools and Bootcamps​
          </a>
          {value === 0 ? (
            <a className="menu_title" href="/securitySchools#I&DInitiatives">
              Identity & Access Management
            </a>
          ) : (
            ""
          )}
          {value === 1 ? (
            <a className="menu_title" href="/securitySchools#InfrastructureSecurity">
              Infrastructure Security
            </a>
          ) : (
            ""
          )}
          {value === 2 ? (
            <a className="menu_title" href="/securitySchools#platformsecurity">
              Platform Security
            </a>
          ) : (
            ""
          )}
          {value === 3 ? (
            <a className="menu_title" href="/securitySchools#cloudsecurity">
              Cloud Security
            </a>
          ) : (
            ""
          )}
          <a className="menu_title" href="">
            SailPoint IDN​
          </a>
        </Breadcrumbs>
      </div>
      <div className="main-container">
        <Box className="boxStyles">
          <Box
            sx={{ borderBottom: 0, borderColor: "divider" }}
            className="tabMenuWrap"
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              centered
            >
              <Tab
                label="Identity & Access Management​"
                {...a11yProps(0)}
                className="tabStyles"
              />
              <Tab
                label="Infrastructure Security"
                {...a11yProps(1)}
                className="tabStyles"
              />
              <Tab
                label="Platform Security"
                {...a11yProps(2)}
                className="tabStyles"
              />
              <Tab
                label="Cloud Security"
                {...a11yProps(3)}
                className="tabStyles"
                // href='https://atci.lkm.delivery.accenture.com/ProfessionalSkills/' target='_blank'
              />
            </Tabs>
          </Box>
          <TabPanel className="tabPanelWrap" value={value} index={0}>
            {/* Section 1  */}
            <div className="SPIN-about-container">
              <div className="SPIN-about-wrap">
                <div className="SPIN-about-row">
                  <div className="SPIN-about-box box1">
                    <img
                      src="images/SecuritySchools/SailPoint/About.png"
                      alt=""
                    />
                  </div>
                  <div className="SPIN-about-box box2">
                    <h2>About the SailPoint IdentityNow Program</h2>
                    <p>
                      SailPoint IdentityNow is an instructor-led training that
                      covers the concepts of application onboarding and
                      correlation, troubleshooting, debugging, and console. The
                      course will help participants work with workflows,
                      reports, provisioning, and engines.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* section 2 */}
            <div className="objectives-container">
              <div className="objectives-wrap">
                <h2>Key Objectives:</h2>
                <div className="objectives-row">
                  <div className="objectives-box">
                    <img
                      src="images/SecuritySchools/SailPoint/Introduction.png"
                      alt="key-objectives-icon"
                    />
                    <p>Introduction to Identity Now</p>
                  </div>
                  <div className="objectives-box">
                    <img
                      src="images/SecuritySchools/SailPoint/To-learn.png"
                      alt="key-objectives-icon"
                    />
                    <p>
                      To learn more about Password policies, management flow,
                      and synchronization
                    </p>
                  </div>
                  <div className="objectives-box">
                    <img
                      src="images/SecuritySchools/SailPoint/Management-and-Provisioning.png"
                      alt="key-objectives-icon"
                    />
                    <p>
                      Provide an in-depth understanding of Access Management and
                      Provisioning
                    </p>
                  </div>
                  {/* </div> */}
                  {/* <div className="objectives-row"> */}
                  <div className="objectives-box">
                    <img
                      src="images/SecuritySchools/SailPoint/Event-Triggers-and-Workflows.png"
                      alt=""
                    />
                    <p>To understand Event Triggers and Workflows</p>
                  </div>
                  <div className="objectives-box">
                    <img
                      src="images/SecuritySchools/SailPoint/Rest-APIs.png"
                      alt=""
                    />
                    <p>
                      Introduction to Rest APIs, Identity Now Transforms, and
                      Rules
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* section 3  */}
            <div className="topics-container">
              <div className="topics-wrap">
                <h2>Topics in Focus</h2>
                <div className="topics-row">
                  <div className="topics-list">
                    <ul>
                      <li>Overview of Identity and Access Management</li>
                      <li>Managing Access, Requests, and Provisioning</li>
                      <li>Search</li>
                      <li>Overview of IdentityNow tenant</li>
                      <li>Password Management</li>
                      <li>Certification</li>
                      <li>Virtual Appliance and NELM Module</li>
                      <li>Configuration of system settings</li>
                      <li>Separation of Duties</li>
                      <li>Introduction to Workflows and Triggers</li>
                      <li>Export and Import of objects</li>
                      <li>Comparison of IdentityNow and IdentityIQ</li>
                      <li>
                        Postman/Visual Studio Code configuration and rest API
                        calls
                      </li>
                      <li>Build a Transformation and Rules</li>
                    </ul>
                  </div>
                  <div className="bottomCorner">
                    <img
                      src="images/SecuritySchools/SailPoint/corner.png"
                      className="img-responsive"
                      alt="corner"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* section 4  */}
            <div className="duration-container">
              <div className="row1-bottom-section">
                <div>
                  <p className="border-Heading">
                    <span>Total Duration: 60+ hours, spanned over 4 weeks</span>
                    <img
                      src="images/SecuritySchools/SecurityPlatforms/arrow.png"
                      alt=""
                    />
                  </p>
                  <p>
                    <span className="bold">Training model :</span> <br></br>
                    <span className="light">VILT + Hands-on + Assessments</span>
                    ​
                  </p>
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel className="tabPanelWrap" value={value} index={1}>
            <InfrastructureSecurity />
          </TabPanel>
          <TabPanel className="tabPanelWrap" value={value} index={2}>
            <PlatformSecurity />
          </TabPanel>
          <TabPanel className="tabPanelWrap" value={value} index={3}>
            <CloudSecurity />
          </TabPanel>
        </Box>
      </div>
    </>
  );
}

export default SailPointIdentityNow;

